'use strict'

const isPristine = Symbol('isPristine')

module.exports.isPristine = isPristine
